module.exports = __webpack_public_path__ + "images/svg/bg_magenta_bubbles_outline.svg";